// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"209":"transaction","398":"card-reader","535":"login"}[chunkId] + "." + {"209":"c39349e7","398":"a75f92bf","535":"37500b58"}[chunkId] + ".css";
};